import DOMPurify from "dompurify";

/**
 * Sanea HTML antes de inyectarlo con `dangerouslySetInnerHTML`.
 *
 * Defensa en profundidad (bloque 0 de la auditoría): el backend ya sanea el
 * `content_html` al persistir, pero cualquier HTML que se renderice sin pasar
 * por el editor (historial de versiones, preview de generación) se limpia aquí
 * también para que un dato ya envenenado en BD no ejecute JS en el navegador.
 */
export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return "";
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}
